import { createGlobalState, useStorage } from '@vueuse/core';

export const useUserPreferences = createGlobalState(
  () => {
    const state = useStorage('MMY_USER_PREFERENCES',
      {
        autoAdvance: true,
        autoplay: true,
        volume: 1,
        captions: false,
        language: 'en',
        playbackRate: 1,
      },
      localStorage, { mergeDefaults: true },
    );

    // Getters
    const autoAdvance = computed(() => state.value.autoAdvance);
    const autoplay = computed(() => state.value.autoplay);
    const volume = computed(() => state.value.volume);
    const captions = computed(() => state.value.captions);
    const language = computed(() => state.value.language);
    const playbackRate = computed(() => state.value.playbackRate);

    // Setters
    const setAutoAdvance = (value: boolean) => state.value.autoAdvance = value;
    const setAutoplay = (value: boolean) => state.value.autoplay = value;
    const setVolume = (value: number) => state.value.volume = value;
    const setCaptions = (value: boolean) => state.value.captions = value;
    const setLanguage = (value: string) => state.value.language = value;
    const setPlaybackRate = (value: number) => state.value.playbackRate = value;

    return {
      autoAdvance,
      autoplay,
      volume,
      captions,
      language,
      playbackRate,

      setAutoAdvance,
      setAutoplay,
      setVolume,
      setCaptions,
      setLanguage,
      setPlaybackRate,
    };
  },
);